export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";